import React from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { DashboardMetric } from 'modules';
import { Box } from '@mui/material';


export type TaskSummaryMetricsSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TaskSummaryMetricsSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const metricNames: (keyof typeof data)[] = [
    'newTasks',
    'overdueTasks',
    'dueTasks',
    'completedTasks'
  ];
  return (
    <Box
      display='flex'
      flexDirection='row'
      columnGap='1rem'
      justifyContent='space-between'
    >
      {
        metricNames.map((node, i) => (
          <DashboardMetric.FC
            key={`${data[node].id}${i}`}
            metricType={data[node].metricType}
            count={data[node].count}
            title={data[node].title}
          />
        ))
      }
    </Box>

  );
};
